/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AuthService } from './@core/services/auth.service';
import { ConfiguracoesService } from './@core/services/configuracoes.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {

  constructor(private authService: AuthService, private configuracoesService: ConfiguracoesService) {
  }

  ngOnInit(): void {
    this.authService.onAuthComplete.subscribe({
      next: autenticado => {
        if(autenticado) {
          this.getStatics();
        }
      }
    })
    this.authService.autenticar();
  }

  private getStatics() {
    this.configuracoesService.getStatics().subscribe({
      next: statics => {
        this.configuracoesService.statics = statics.data;
      }
    });
  }
}
